import { render, staticRenderFns } from "./NoteInfo.vue?vue&type=template&id=4effd2ac&"
import script from "./NoteInfo.vue?vue&type=script&lang=js&"
export * from "./NoteInfo.vue?vue&type=script&lang=js&"
import style0 from "./NoteInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports